import apiClient from '@/services/axios'

export async function post(createBookingCommand, acceptSoftWarnings) {
  let acceptSoftWarningsString = '';
  if(acceptSoftWarnings) {
    acceptSoftWarningsString = '?accept-soft-warnings=true';
  }
  var response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/bookings' + acceptSoftWarningsString, createBookingCommand);

  if (response) {
    console.log(response);
    return response.data;
  }

  throw new Error('Unable to post booking.')
}
